<template>
  <div class="price-dimension-page" data-test="price-dimension-page">
    <div class="add-area show van-hairline--bottom">
      <div class="add-area__info">
        课程属性：{{ totalCount }}
        <van-popover
          v-model="showPopover"
          trigger="click"
          placement="bottom-start"
          theme="dark"
          :offset="[-8, 6]"
        >
          配置机构自己的课程属性，可用于更详细的课程归类管理
          <template #reference>
            <van-icon name="question-o" style="vertical-align: middle" />
          </template>
        </van-popover>
      </div>
      <div
        class="add-btn"
        @click="addPriceDimension"
        data-test="price-dimension-page-add-btn"
        v-if="app.permission.op('edit_pirce_dimension')"
      >
        <van-icon name="plus" />
        &nbsp;
        <div class="add-btn__text">新增属性</div>
      </div>
    </div>
    <vx-list class="main-wrapper mb" :api="api" :pageSize="999" @load="onLoad" ref="listScroller">
      <!-- 用户创建的定价维度 -->
      <div
        class="dimension-box"
        :class="{ disabled: item.priceDimensionStatus == false }"
        v-for="(item, index) in list"
        :key="item.id"
      >
        <div class="item-top">
          <div class="item-name">{{ item.dimensionName }}</div>
          <div class="item-status">
            <van-switch
              :disabled="disableEnable && !item.priceDimensionStatus"
              :value="item.priceDimensionStatus"
              size="calc(var(--w) * 24)"
              inactive-color="var(--g5)"
              @click="verifyCanEnable(item, index)"
            />
          </div>
        </div>
        <div class="item-content">
          <div class="item-main">
            <div
              class="item-option"
              :class="{ disabled: item.priceDimensionStatus == false }"
              v-for="(sitem, sindex) in item.basePriceDimensionDetailList"
              :key="sindex"
            >
              {{ sitem.dimensionValue }}
            </div>
          </div>
          <div
            class="item-op"
            @click="editPriceDimension(item.id)"
            v-if="app.permission.op('edit_pirce_dimension')"
          >
            编辑
          </div>
        </div>
      </div>
    </vx-list>
    <pageFooterBtn
      btnText="确认"
      v-if="$route.query.moreDimension"
      data-test="price-dimension-page-choose-btn"
      @click="confirmPriceDimension"
    />
  </div>
</template>

<script>
import pageFooterBtn from '@x3/vue/comp/page-footer-btn.vue';
export default {
  components: { pageFooterBtn },
  data() {
    return {
      pageTitle: '课程属性',
      list: [],
      actions: [],
      api: this.$api.basePriceDimensionDetailList,
      showPopover: false,
      totalCount: 0,
    };
  },
  computed: {
    disableEnable() {
      let enableList = this.list.filter(v => v.priceDimensionStatus);
      return enableList.length >= 10;
    },
  },
  methods: {
    onLoad(list, res) {
      this.list = list;
      this.totalCount = res && res.page && res.page.totalCount;
      vant.Toast.clear();
    },
    addPriceDimension() {
      this.$router.push('/pirceDimensionAdd?disableEnable=' + Number(this.disableEnable));
    },
    editPriceDimension(id) {
      this.$router.push('/pirceDimensionAdd?id=' + id);
    },
    updatePriceDimensionStatus(index) {
      this.showLoading();
      this.$api
        .basePriceDimensionUpdate(
          Object.assign({}, this.list[index], {
            priceDimensionStatus: !this.list[index].priceDimensionStatus,
          })
        )
        .then(res => {
          if (res.code === 200) {
            this.$toast.success('修改成功');
            // 如果是价格创建进入维度页面，状态更改立即通知价格创建/编辑页面
            // 但不返回到上一个页面
            this.list[index].priceDimensionStatus = !this.list[index].priceDimensionStatus;
            if (this.$route.query.moreDimension) {
              this.confirmPriceDimension(true);
            }
          } else {
            this.$toast.fail(res.msg || '修改失败');
          }
        });
    },
    // 验证是否超过可启用个数，除了限制外添加提示
    verifyCanEnable(item, idx) {
      if (!app.permission.op('edit_pirce_dimension')) {
        return;
      }
      if (!item.priceDimensionStatus && this.disableEnable) {
        this.$toast('价格维度最多启用10个');
        return false;
      }
      // if (
      //   item.priceDimensionStatus &&
      //   this.list.filter(item => {
      //     return item.priceDimensionStatus === true;
      //   }).length === 1
      // ) {
      //   this.$toast.fail('至少要启用1个定价维度');
      //   return;
      // }
      this.updatePriceDimensionStatus(idx);
    },
    // 确认维度操作，返回价格创建页面
    confirmPriceDimension(noBack) {
      let newList = [];
      this.list.map(v => {
        v.priceDimensionStatus && newList.push({ ...v });
      });
      noBack && vant.Toast.clear();
      app.vue.$emit('confirmChoosetPriceDimensions', newList);
      !noBack && this.$router.back();
    },
  },
  mounted() {
    this.showLoading();
    this.$onBus('refresh-price-list', async () => {
      try {
        await this.$refs.listScroller.refresh();
        // 编辑维度值、或者新增价格维度，更新到创建/编辑价格页面
        // 但是不返回
        this.confirmPriceDimension(true);
      } catch (err) {
        console.log(err);
      }
    });
  },
  beforeDestroy() {},
};
</script>

<style lang="scss" scoped>
.price-dimension-page {
  display: flex;
  flex-direction: column;
  background-color: var(--g1);
  font-size: var(--fs-md);
  .main-wrapper {
    flex: 1;
    overflow-y: scroll;
    .dimension-box {
      background-color: var(--white);
      margin: calc(var(--gap) * 12) calc(var(--gap) * 16) 0;
      border-radius: var(--radius-sm);
      .item-top {
        display: flex;
        align-items: center;
        padding: calc(var(--gap) * 8) calc(var(--gap) * 16);
        font-size: var(--fs-lg);
        line-height: var(--lh-lg);
        font-weight: var(--bold);
        border-top-left-radius: var(--radius-sm);
        border-top-right-radius: var(--radius-sm);
        background-color: rgba(var(--g2-rgb), 0.3);
        .item-name {
          flex: 1;
        }
        .item-status {
          line-height: 0;
        }
      }
      .item-content {
        position: relative;
        border-bottom-left-radius: var(--radius-sm);
        border-bottom-right-radius: var(--radius-sm);
        .item-main {
          padding: calc(var(--gap) * 12) 52px calc(var(--gap) * 12) calc(var(--gap) * 16);
          font-size: var(--fs-md);
          line-height: var(--lh-md);
          color: var(--g6);
          border-bottom-left-radius: var(--radius-sm);
          border-bottom-right-radius: var(--radius-sm);
          .item-option {
            display: inline-block;
            position: relative;
            margin-right: calc(var(--gap) * 16);
            &:not(:last-child)::after {
              position: absolute;
              content: '';
              width: 1px;
              height: calc(var(--w) * 14);
              margin: 0 calc(var(--gap) * 8);
              bottom: calc(var(--gap) * 4);
              background-color: var(--g6);
              transform: scaleX(0.5);
            }
            &.disabled:not(:last-child)::after {
              border-right: 1px solid var(--g5) !important;
            }
          }
        }
        .item-op {
          position: absolute;
          right: calc(var(--w) * 16);
          color: var(--tlc);
          font-size: var(--fs-md);
          line-height: var(--lh-md);
          top: 50%;
          transform: translateY(-50%);
        }
      }
      &.disabled {
        color: var(--g5) !important;
        .item-main {
          color: var(--g5) !important;
        }
      }
    }
  }
  .btn {
    position: absolute;
    bottom: 0;
    width: 100%;
  }
}
</style>
<style lang="scss" scoped>
.price-dimension-page {
  .add-area__info {
    display: flex;
    align-items: center;
    .van-popover__wrapper {
      padding-left: calc(var(--gap) * 2);
      display: flex;
      align-items: center;
    }
  }
}
</style>